<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
          <div class="text-dash">
          <h1>Dashboard</h1>
          </div>
          <div class="dashboard">
            <router-link to="#" class="card-icon" title="Email Verified + Mobile Verified + Active">
              <div class="card-icon-body">
                <div class="card-icon-i">
                  <div class="count-c">
                    <h2>{{allRegisterdUsers}}</h2>
                  </div>
                </div>
                <h3>Registered Users</h3>
              </div>
            </router-link>


            <router-link to="#" class="card-icon" title="Email Verified + Mobile Verified + Active">
              <div class="card-icon-body">
                <div class="card-icon-i">
                  <div class="count-c">
                    <h2>{{subscribedUsers}}</h2>
                  </div>
                </div>
                <h3>Subscribed Users</h3>
              </div>
            </router-link>
            
           
            
            <router-link to="#" class="card-icon" title="Email Verified + Mobile Verified + Active + Plan Opted">
              <div class="card-icon-body">
                <div class="card-icon-i">
                   <div class="count-c">
                    <h2>{{freeUsers}}</h2>
                  </div>
                </div>
                <h3>Subscribed Users (WTP)</h3>
              </div>
            </router-link>
            <router-link to="#" class="card-icon" title="Email Verified + Mobile Verified + Active + Plan Opted + Payment">
              <div class="card-icon-body">
                <div class="card-icon-i">
                 <div class="count-c">
                    <h2>{{unpaidUsers}}</h2>
                  </div>
                </div>
                <h3>Subscribed Users (OTP)</h3>
              </div>
            </router-link>
            <router-link to="#" class="card-icon" title="Email Verified + Mobile Verified + Active + Plan Opted + Trail Period Expired">
              <div class="card-icon-body">
                <div class="card-icon-i">
                   <div class="count-c">
                    <h2>{{paidUsers}}</h2>
                  </div>
                </div>
                <h3>Subscribed Users (Made Payment)</h3>
              </div>
            </router-link>
            <router-link to="#" class="card-icon" title="Email Verified + Mobile Verified + Active + Plan Opted + Trail Period Expired">
              <div class="card-icon-body">
                <div class="card-icon-i">
                   <div class="count-c">
                    <h2>{{sb_but_not_made_payment}}</h2>
                  </div>
                </div>
                <h3>Subscribed Users (Not Made Payment)</h3>
              </div>
            </router-link>
          </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    allCampaign:'',
    allUsers:'',
    allTopic:'',
    allRegisterdUsers:'',
    paidUsers:'',
    freeUsers:'',
    unpaidUsers:'',
    subscribedUsers:'',
    sb_but_not_made_payment:''
    
  }),
  methods: {},
  mounted() {
    
    if(localStorage.getItem('marketing_data') !=''){
      let marketingData = JSON.parse(localStorage.getItem('marketing_data'));
      this.allUsers = marketingData.allUser;
      this.allCampaign = marketingData.campaign;
      this.allRegisterdUsers = marketingData.allRegisterdUsers;
      this.allTopic = marketingData.topic;
      this.freeUsers = marketingData.freeUsers;
      this.paidUsers = marketingData.paidUsers;
      this.unpaidUsers = marketingData.unpaidUsers;
      this.subscribedUsers  = marketingData.subscribedUsers;
      this.sb_but_not_made_payment  = marketingData.sb_but_not_made_payment;

    }
    else{
       this.$loading(true);
       axios
        .get(process.env.VUE_APP_ROOT_API + "user-count" , {
        })
        .then((response) => {
          localStorage.setItem('marketing_data',JSON.stringify(response.data.data))
          this.allUsers = response.data.data.allUser;
          this.allCampaign = response.data.data.campaign;
          this.allRegisterdUsers = response.data.data.allRegisterdUsers;
          this.allTopic = response.data.data.topic;
          this.freeUsers = response.data.data.freeUsers;
          this.paidUsers = response.data.data.paidUsers;
          this.unpaidUsers = response.data.data.unpaidUsers;
          this.subscribedUsers  = response.data.data.subscribedUsers;
          this.sb_but_not_made_payment  = response.data.data.sb_but_not_made_payment;
          this.$loading(false);
        });
    }  
  },
};
</script>